export default __webpack_public_path__ + "static/media/icon-5g.1116923b.svg";